const message = {
    SEVER_ERROR: "出错了，请稍后再试！",
}


export default message;